import { IKho } from "../../model/respone/category/IKho"
import { apiClient } from "../apiClient"

export const KHO_API_RESOURCE = "kho"
export const khoApi = {
    SelectAll: () => apiClient.get(`${KHO_API_RESOURCE}`),
    Insert: (payload: IKho) => apiClient.post(`${KHO_API_RESOURCE}`,payload),
    Update: (payload: IKho) => apiClient.put(`${KHO_API_RESOURCE}`,payload),
    Delete: (id: number) => apiClient.delete(`${KHO_API_RESOURCE}/${id}`),
    SelectById: (id: number) => apiClient.get(`${KHO_API_RESOURCE}/select_by_id/${id}`),
    SelectTruongByKhoId: (id: number) => apiClient.get(`${KHO_API_RESOURCE}/select_truong_by_kho_id/${id}`),
    DeleteTruongByKhoId: (payload: any) => apiClient.post(`${KHO_API_RESOURCE}/delete_truong_by_kho_id`, payload),
    UpdateTruongByKhoId: (payload: any) => apiClient.put(`${KHO_API_RESOURCE}/update_truong_by_kho_id`, payload),
}